(function () {
  'use strict';

  var raiz = document.querySelector('[data-szpr]');
  if (!raiz) { return; }

  var BASE = (raiz.getAttribute('data-api-base') || 'https://theultron.com').replace(/\/+$/, '');
  var URL_CUPOM = BASE + raiz.getAttribute('data-rota-cupom');
  var URL_CADASTRO = BASE + raiz.getAttribute('data-rota-cadastro');

  var TEMPO_LIMITE = 9000;   // ms por requisicao
  var DEBOUNCE = 500;        // ms depois da ultima tecla
  var MIN_CUPOM = 3;
  var MAX_SONDAS = 6;        // teto de sugestoes sondadas, o endpoint tem rate-limit
  var MAX_ATEND = 500;       // teto de atendimentos por semana, em cada uma das duas perguntas

  var form = document.getElementById('szpr-form');
  var card = document.getElementById('szpr-card');
  var btn = document.getElementById('szpr-btn');
  var spin = document.getElementById('szpr-spin');
  var elStatus = document.getElementById('szpr-status-cupom');
  var caixaSug = document.getElementById('szpr-sugestoes');
  var chips = document.getElementById('szpr-sug-chips');
  var erroGeral = document.getElementById('szpr-erro-geral');

  var campos = {
    nome: document.getElementById('szpr-nome'),
    telefone: document.getElementById('szpr-telefone'),
    email: document.getElementById('szpr-email'),
    crn: document.getElementById('szpr-crn'),
    instagram: document.getElementById('szpr-instagram'),
    faz_atendimentos: document.getElementById('szpr-faz-atend'),   // o fieldset dos radios
    cupom_base: document.getElementById('szpr-cupom'),
    consent: document.getElementById('szpr-consent')
  };
  var erros = {
    nome: document.getElementById('szpr-erro-nome'),
    telefone: document.getElementById('szpr-erro-telefone'),
    email: document.getElementById('szpr-erro-email'),
    crn: document.getElementById('szpr-erro-crn'),
    instagram: document.getElementById('szpr-erro-instagram'),
    faz_atendimentos: document.getElementById('szpr-erro-faz-atend'),
    cupom_base: document.getElementById('szpr-erro-cupom'),
    consent: document.getElementById('szpr-erro-consent')
  };

  // "Voce faz atendimentos?": os dois radios, os rotulos-pilula, o resumo e o modal.
  var radioSim = document.getElementById('szpr-faz-atend-sim');
  var radioNao = document.getElementById('szpr-faz-atend-nao');
  var rotuloSim = document.getElementById('szpr-radio-sim');
  var rotuloNao = document.getElementById('szpr-radio-nao');
  var resumo = document.getElementById('szpr-resumo-atend');
  var resumoTexto = document.getElementById('szpr-resumo-atend-texto');
  var btnEditar = document.getElementById('szpr-editar-atend');
  var modal = {
    dialogo: document.getElementById('szpr-modal-atend'),
    form: document.getElementById('szpr-modal-form'),
    presenciais: document.getElementById('szpr-atend-presenciais'),
    online: document.getElementById('szpr-atend-online'),
    erroPresenciais: document.getElementById('szpr-erro-presenciais'),
    erroOnline: document.getElementById('szpr-erro-online'),
    confirmar: document.getElementById('szpr-modal-confirmar'),
    cancelar: document.getElementById('szpr-modal-cancelar')
  };

  /* ------------------------------------------------------ 1. NORMALIZACAO */

  // A faixa dos acentos combinantes (U+0300 a U+036F) montada por codigo de caractere, em
  // ASCII puro: sem sequencia de escape no fonte (o caminho de upload do tema a decodifica e
  // o md5 deixa de bater) e sem o caractere literal (editor e minificador tropecam nele).
  var ACENTOS = new RegExp('[' + String.fromCharCode(768) + '-' + String.fromCharCode(879) + ']', 'g');
  function semAcento(txt) {
    var s = String(txt || '');
    if (s.normalize) { s = s.normalize('NFD').replace(ACENTOS, ''); }
    return s;
  }

  // O cupom e o unico campo com forma fechada: MAIUSCULO, sem acento, so A-Z e 0-9.
  function normCupom(bruto) {
    return semAcento(bruto).toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 20);
  }

  function soDigitos(bruto) { return String(bruto || '').replace(/\D/g, ''); }

  // Mascara brasileira. 10 digitos: (11) 3456-7890. 11 digitos: (11) 98765-4321.
  function mascaraFone(bruto) {
    var d = soDigitos(bruto).slice(0, 11);
    if (!d.length) { return ''; }
    if (d.length <= 2) { return '(' + d; }
    var ddd = d.slice(0, 2);
    var resto = d.slice(2);
    if (resto.length <= 4) { return '(' + ddd + ') ' + resto; }
    if (resto.length <= 8) { return '(' + ddd + ') ' + resto.slice(0, 4) + '-' + resto.slice(4); }
    return '(' + ddd + ') ' + resto.slice(0, 5) + '-' + resto.slice(5);
  }

  function foneValido(bruto) {
    var d = soDigitos(bruto);
    if (d.length !== 10 && d.length !== 11) { return false; }
    var ddd = parseInt(d.slice(0, 2), 10);
    if (!(ddd >= 11 && ddd <= 99)) { return false; }
    if (d.length === 11 && d.charAt(2) !== '9') { return false; }
    return true;
  }

  // E.164, o mesmo formato que o pop-up ja manda pro Ultron.
  function foneE164(bruto) {
    var d = soDigitos(bruto);
    if (d.indexOf('55') === 0 && d.length >= 12) { return '+' + d; }
    return '+55' + d;
  }

  function emailValido(bruto) {
    var v = String(bruto || '').trim();
    if (v.length < 6 || v.length > 160) { return false; }
    return /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/.test(v);
  }

  // Aceita "@perfil", "perfil", "instagram.com/perfil", "https://www.instagram.com/perfil/".
  function normInstagram(bruto) {
    var v = semAcento(bruto).trim().toLowerCase();
    if (!v) { return ''; }
    v = v.replace(/^https?:\/\//, '').replace(/^www\./, '').replace(/^instagram\.com\//, '');
    v = v.split('?')[0].split('/')[0];
    v = v.replace(/^@+/, '').replace(/[^a-z0-9._]/g, '');
    return v.slice(0, 30);
  }

  /* CRN. O prefixo "CRN" e um afixo FIXO na tela: ela nao digita a sigla, digita so o
     numero, e o campo aceita SO digito (se ela colar "CRN-3 12345", sobra "312345" e o
     digito da regiao continua sendo o primeiro do numero, so que sem separador).
     O valor que vai pro backend e montado em `crnCompleto`, no envio: "CRN 312345".
     Minimo de 3 digitos, teto de 10, do mesmo tamanho do maxlength do campo. */
  var CRN_PREFIXO = 'CRN';
  var CRN_MIN_DIGITOS = 3;

  function crnDigitos(bruto) { return soDigitos(bruto).slice(0, 10); }

  function crnCompleto(bruto) {
    var d = crnDigitos(bruto);
    return d ? (CRN_PREFIXO + ' ' + d) : '';
  }

  /* As duas quantidades do modal: inteiro de 0 a MAX_ATEND, sem sinal, sem decimal.
     Devolve o numero, ou null quando o texto nao e um inteiro nessa faixa. "12,5", "-3",
     "abc" e "" viram null; " 12 " vira 12. */
  function quantidade(bruto) {
    var v = String(bruto === null || bruto === undefined ? '' : bruto).trim();
    if (!/^[0-9]{1,3}$/.test(v)) { return null; }
    var n = parseInt(v, 10);
    if (n < 0 || n > MAX_ATEND) { return null; }
    return n;
  }

  /* Rastreio do cadastro, lido da URL na hora do envio. Tres pecas, cada uma so entra no
     corpo quando existe (sem parametro a chave nem e criada):
       origem  ?origem=instagram|email|..., ou ?utm_source=instagram|ig|email (vira o canal)
       uf      ?uf=RJ  (duas letras; o link do e-mail ja sai com a UF da nutricionista)
       ref     ?ref=<token>  (quem e ela na campanha: e o que liga o cadastro ao e-mail
               que ela recebeu; nunca o e-mail dela, que nao vai em URL)
     Nada fica guardado alem desta pagina. Valor de origem desconhecido vai como esta (o
     backend normaliza); uf e ref fora do formato nem saem daqui. */
  function leRastreioDaUrl(busca) {
    var r = { origem: null, uf: null, ref: null, utm_source: null, utm_medium: null,
      utm_campaign: null, utm_content: null, fbclid: null };
    var q = String(busca || '');
    if (q.charAt(0) === '?') { q = q.slice(1); }
    if (!q) { return r; }
    var partes = q.split('&');
    var utm = null;
    for (var i = 0; i < partes.length; i++) {
      var par = partes[i].split('=');
      var k = '';
      var bruto = '';
      try {
        k = decodeURIComponent(par[0] || '').trim().toLowerCase();
        bruto = decodeURIComponent((par[1] || '').replace(/[+]/g, ' ')).trim();
      } catch (e) { continue; }
      var v = bruto.toLowerCase();
      if (k === 'origem' && v) { r.origem = v.slice(0, 40); }
      if (k === 'utm_source' && v) { utm = v; }
      if (k === 'uf' && /^[a-z]{2}$/.test(v)) { r.uf = v.toUpperCase(); }
      // o ref mantem a caixa: token de campanha e comparado letra por letra no backend
      if (k === 'ref' && /^[A-Za-z0-9_-]{1,64}$/.test(bruto)) { r.ref = bruto; }
      /* etapa41 (27/set/26): o rastreio do anuncio. As UTMs vao cruas (so aparadas e
         cortadas em 150); o fbclid so no alfabeto que a Meta usa. O backend normaliza. */
      if ((k === 'utm_source' || k === 'utm_medium' || k === 'utm_campaign' || k === 'utm_content') && bruto) {
        r[k] = bruto.slice(0, 150);
      }
      if (k === 'fbclid' && /^[A-Za-z0-9_-]{1,500}$/.test(bruto)) { r.fbclid = bruto; }
    }
    /* Clique de anuncio (fbclid, ou utm_medium pago) nao vira origem instagram aqui: o
       backend separa anuncio de bio pelo par fonte e meio. */
    var meio = String(r.utm_medium || '').toLowerCase();
    var pago = ['paid', 'paid_social', 'paidsocial', 'cpc', 'cpm', 'ppc', 'ads', 'ad', 'pago', 'anuncio'].indexOf(meio) !== -1;
    if (!r.origem && !r.fbclid && !pago) {
      if (utm === 'instagram' || utm === 'ig') { r.origem = 'instagram'; }
      if (utm === 'email') { r.origem = 'email'; }
    }
    return r;
  }

  /* ---------------------------------------------------------- 2. MENSAGEM */

  // O CRN mora dentro de uma caixa com o afixo "CRN", e quem desenha a borda e a CAIXA,
  // nao o input. Por isso o estado de erro dele vai numa classe da caixa: assim funciona
  // em navegador sem :has(), e nao so nos novos.
  var caixaCrn = document.querySelector('.szpr-afixo-box');

  function pintaCaixaCrn(comErro) {
    if (!caixaCrn) { return; }
    var cls = caixaCrn.className.replace(/\s*szpr-afixo-erro/g, '');
    caixaCrn.className = comErro ? (cls + ' szpr-afixo-erro') : cls;
  }

  function mostraErro(campo, texto) {
    var el = erros[campo];
    var inp = campos[campo];
    if (el) { el.textContent = texto; }
    if (inp && inp.type !== 'checkbox') { inp.setAttribute('aria-invalid', 'true'); }
    if (campo === 'crn') { pintaCaixaCrn(true); }
  }

  function limpaErro(campo) {
    var el = erros[campo];
    var inp = campos[campo];
    if (el) { el.textContent = ''; }
    if (inp) { inp.removeAttribute('aria-invalid'); }
    if (campo === 'crn') { pintaCaixaCrn(false); }
  }

  function limpaTudo() {
    for (var k in erros) { if (Object.prototype.hasOwnProperty.call(erros, k)) { limpaErro(k); } }
    erroGeral.textContent = '';
  }

  function dizStatus(estado, texto) {
    if (!texto) { elStatus.textContent = ''; elStatus.removeAttribute('data-estado'); return; }
    elStatus.textContent = texto;
    elStatus.setAttribute('data-estado', estado);
  }

  function girando(liga) { spin.hidden = !liga; }

  /* ------------------------------------------ 3. "VOCE FAZ ATENDIMENTOS?" */

  /* O estado da resposta mora AQUI, nao nos campos do modal: o modal pode ser aberto de
     novo, mexido e cancelado, e o que vale e o que foi CONFIRMADO da ultima vez.
       resposta    'sim' | 'nao' | null (ainda nao marcou)
       confirmado  true so depois de Confirmar com os dois numeros validos
       presenciais / online   os inteiros confirmados (null ate la) */
  var atend = { resposta: null, confirmado: false, presenciais: null, online: null };

  function marcaRotulo(rotulo, marcado) {
    if (!rotulo) { return; }
    var cls = rotulo.className.replace(/\s*szpr-radio-marcado/g, '');
    rotulo.className = marcado ? (cls + ' szpr-radio-marcado') : cls;
  }

  function pintaRadios() {
    marcaRotulo(rotuloSim, !!radioSim.checked);
    marcaRotulo(rotuloNao, !!radioNao.checked);
  }

  function plural(n, um, varios) { return n + ' ' + (n === 1 ? um : varios); }

  // O que ela respondeu fica visivel FORA do modal. Sem isto o envio some com a resposta.
  function pintaResumo() {
    if (atend.resposta !== 'sim') { resumo.hidden = true; resumoTexto.textContent = ''; return; }
    if (atend.confirmado) {
      resumoTexto.textContent = plural(atend.presenciais, 'presencial', 'presenciais') + ' + ' + atend.online + ' online por semana.';
      btnEditar.textContent = 'editar';
      btnEditar.setAttribute('aria-label', 'Editar as quantidades de atendimentos');
    } else {
      resumoTexto.textContent = 'Faltam as duas quantidades.';
      btnEditar.textContent = 'Informar quantidades';
      btnEditar.setAttribute('aria-label', 'Informar as quantidades de atendimentos');
    }
    resumo.hidden = false;
  }

  function limpaErrosDoModal() {
    modal.erroPresenciais.textContent = '';
    modal.erroOnline.textContent = '';
    modal.presenciais.removeAttribute('aria-invalid');
    modal.online.removeAttribute('aria-invalid');
  }

  // Confirmar so habilita com os DOIS preenchidos. A validacao de faixa e da soma continua
  // no clique, com a mensagem colada no campo: botao desligado nao explica nada sozinho.
  function atualizaConfirmar() {
    var p = String(modal.presenciais.value || '').trim();
    var o = String(modal.online.value || '').trim();
    modal.confirmar.disabled = !(p.length && o.length);
  }

  function abreModal() {
    // Reabrir no meio da saida animada: conclui o fechamento pendente e abre limpo.
    if (fechando.ativo) { concluiFechamento(); }
    modal.presenciais.value = atend.presenciais === null ? '' : String(atend.presenciais);
    modal.online.value = atend.online === null ? '' : String(atend.online);
    limpaErrosDoModal();
    atualizaConfirmar();
    modal.dialogo.returnValue = '';
    if (typeof modal.dialogo.showModal === 'function') {
      try { modal.dialogo.showModal(); } catch (e) { modal.dialogo.setAttribute('open', ''); }
    } else {
      modal.dialogo.setAttribute('open', '');   // sem <dialog> modal: abre como caixa comum
    }
    if (modal.presenciais.focus) { modal.presenciais.focus(); }
  }

  /* O fechamento e ANIMADO (02/set/26): a classe .szpr-modal-saindo liga a animacao de
     saida do CSS e o close() de verdade so roda quando ela termina (animationend), com
     um fallback de tempo um pouco acima dos 300ms do CSS para navegador que nao dispare
     o evento. Sem suporte a evento de animacao (navegador velho, ambiente de teste),
     fecha na hora, como sempre fechou. O returnValue e o estado nao mudam em nada. */
  var ANIM_SAIDA_FALLBACK_MS = 450;
  var fechando = { ativo: false, motivo: '', timer: null };

  function suportaAnimacao() { return 'onanimationend' in modal.dialogo; }

  function tiraClasseSaindo() {
    modal.dialogo.className = modal.dialogo.className.replace(/\s*szpr-modal-saindo/g, '');
  }

  function fechaModalDeVerdade(motivo) {
    if (typeof modal.dialogo.close === 'function') {
      try { modal.dialogo.close(motivo); return; } catch (e) {}
    }
    modal.dialogo.returnValue = motivo;
    modal.dialogo.removeAttribute('open');
    aoFecharModal();
  }

  function concluiFechamento() {
    if (!fechando.ativo) { return; }
    fechando.ativo = false;
    if (fechando.timer !== null) { clearTimeout(fechando.timer); fechando.timer = null; }
    tiraClasseSaindo();
    fechaModalDeVerdade(fechando.motivo);
  }

  function fechaModal(motivo) {
    if (fechando.ativo) { return; }
    if (!suportaAnimacao()) { fechaModalDeVerdade(motivo); return; }
    fechando.ativo = true;
    fechando.motivo = motivo;
    modal.dialogo.className += ' szpr-modal-saindo';
    fechando.timer = setTimeout(concluiFechamento, ANIM_SAIDA_FALLBACK_MS);
  }

  // O submit do formulario DO MODAL. Valida os dois; so fecha (com returnValue
  // 'confirmar') quando os dois sao inteiros de 0 a 500 e a soma e pelo menos 1.
  function confirmaModal(e) {
    if (e && e.preventDefault) { e.preventDefault(); }
    limpaErrosDoModal();
    var p = quantidade(modal.presenciais.value);
    var o = quantidade(modal.online.value);
    var faixa = 'Use um número inteiro de 0 a ' + MAX_ATEND + '.';
    var primeiro = null;
    if (p === null) {
      modal.erroPresenciais.textContent = String(modal.presenciais.value || '').trim() ? faixa : 'Informe quantos atendimentos presenciais por semana. Se não faz, coloque 0.';
      modal.presenciais.setAttribute('aria-invalid', 'true');
      primeiro = primeiro || modal.presenciais;
    }
    if (o === null) {
      modal.erroOnline.textContent = String(modal.online.value || '').trim() ? faixa : 'Informe quantos atendimentos online por semana. Se não faz, coloque 0.';
      modal.online.setAttribute('aria-invalid', 'true');
      primeiro = primeiro || modal.online;
    }
    if (p !== null && o !== null && p + o < 1) {
      modal.erroPresenciais.textContent = 'Você marcou que faz atendimentos: informe pelo menos 1, presencial ou online.';
      modal.presenciais.setAttribute('aria-invalid', 'true');
      primeiro = modal.presenciais;
    }
    if (primeiro) { if (primeiro.focus) { primeiro.focus(); } return; }
    atend.presenciais = p;
    atend.online = o;
    atend.confirmado = true;
    fechaModal('confirmar');
  }

  /* Roda em TODO fechamento do modal: Confirmar, Cancelar e o Esc (que fecha sem
     returnValue). Fechar sem confirmar NAO desmarca o Sim: a resposta que ela deu fica, o
     radio ganha o erro "complete as duas quantidades" e o botao de reabrir aparece no
     resumo. Se ja havia numeros confirmados de antes, eles continuam valendo. */
  function aoFecharModal() {
    var confirmou = modal.dialogo.returnValue === 'confirmar';
    if (confirmou) {
      limpaErro('faz_atendimentos');
    } else if (atend.resposta === 'sim' && !atend.confirmado) {
      mostraErro('faz_atendimentos', 'Complete as duas quantidades para continuar, ou marque Não.');
    }
    pintaResumo();
    if (atend.resposta === 'sim' && radioSim.focus) { radioSim.focus(); }
  }

  function aoMarcarSim() {
    atend.resposta = 'sim';
    limpaErro('faz_atendimentos');
    pintaRadios();
    pintaResumo();
    abreModal();
  }

  function aoMarcarNao() {
    atend.resposta = 'nao';
    atend.confirmado = false;   // os numeros nao valem mais; se voltar ao Sim, o modal reabre
    limpaErro('faz_atendimentos');
    pintaRadios();
    pintaResumo();
  }

  /* ------------------------------------------------------------ 4. VALIDA */

  // Devolve null quando o campo esta bom, ou a mensagem de erro. A mensagem sempre diz o
  // que fazer, nunca so que esta errado. Desde 02/set/26 nao ha campo opcional.
  function validaCampo(campo) {
    var v = campos[campo] && typeof campos[campo].value === 'string' ? campos[campo].value : '';

    if (campo === 'nome') {
      var n = String(v).trim().replace(/\s+/g, ' ');
      if (n.length < 3) { return 'Escreva seu nome completo, com pelo menos 3 letras.'; }
      if (n.length > 120) { return 'Nome muito longo. Use até 120 caracteres.'; }
      return null;
    }
    if (campo === 'telefone') {
      if (!soDigitos(v).length) { return 'Informe seu celular com DDD, é por onde os cupons chegam.'; }
      if (!foneValido(v)) { return 'Confira o número: são 11 dígitos com DDD, como (11) 90000-0000.'; }
      return null;
    }
    if (campo === 'email') {
      if (!String(v).trim()) { return 'Informe um e-mail para a gente confirmar o cadastro.'; }
      if (!emailValido(v)) { return 'Confira o e-mail, parece faltar o @ ou o final (.com, .com.br).'; }
      return null;
    }
    if (campo === 'crn') {
      var d = crnDigitos(v);
      if (!d.length) { return 'Informe o número do seu CRN. O "CRN" já está no campo.'; }
      if (d.length < CRN_MIN_DIGITOS) { return 'Confira o CRN: o número tem pelo menos ' + CRN_MIN_DIGITOS + ' dígitos.'; }
      return null;
    }
    if (campo === 'instagram') {
      if (!String(v).trim()) { return 'Informe o seu Instagram, é por onde a gente conhece o seu trabalho.'; }
      if (normInstagram(v).length < 2) { return 'Confira o @: use só letras, números, ponto e underline.'; }
      return null;
    }
    if (campo === 'faz_atendimentos') {
      if (!radioSim.checked && !radioNao.checked) { return 'Marque Sim ou Não.'; }
      if (radioSim.checked && !atend.confirmado) { return 'Complete as duas quantidades para continuar, ou marque Não.'; }
      return null;
    }
    if (campo === 'cupom_base') {
      var cup = normCupom(v);
      if (!cup.length) { return 'Escolha o nome do seu cupom, por exemplo DRAJULIA.'; }
      if (cup.length < MIN_CUPOM) { return 'O nome do cupom precisa de pelo menos ' + MIN_CUPOM + ' caracteres.'; }
      if (/^[0-9]+$/.test(cup)) { return 'Use pelo menos uma letra no nome do cupom.'; }
      return null;
    }
    if (campo === 'consent') {
      if (!campos.consent.checked) { return 'Marque a autorização para a gente poder criar seu cupom.'; }
      return null;
    }
    return null;
  }

  /* ------------------------------------------------------------ 5. REDE */

  // Toda ida ao backend passa por aqui. Nunca lanca: devolve um objeto com o desfecho, para
  // que "backend fora do ar" seja um estado tratado e nao uma excecao solta no console.
  function pedir(url, corpo) {
    var ctrl = null;
    var relogio = null;
    try {
      if (window.AbortController) {
        ctrl = new AbortController();
        relogio = setTimeout(function () { try { ctrl.abort(); } catch (e) {} }, TEMPO_LIMITE);
      }
    } catch (e) { ctrl = null; }

    var opcoes = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(corpo)
    };
    if (ctrl) { opcoes.signal = ctrl.signal; }

    return fetch(url, opcoes).then(function (r) {
      if (relogio) { clearTimeout(relogio); }
      return r.text().then(function (txt) {
        var dados = null;
        try { dados = txt ? JSON.parse(txt) : null; } catch (e) { dados = null; }
        return { rede: true, http: r.status, ok: r.ok, dados: dados };
      });
    })['catch'](function () {
      if (relogio) { clearTimeout(relogio); }
      return { rede: false, http: 0, ok: false, dados: null };
    });
  }

  var cache = {};   // nome normalizado -> true (livre) / false (ocupado)

  /* Desfechos: 'livre', 'ocupado', 'limite', 'fora'.
     Contrato do backend (POST checar-cupom, corpo { cupom_base }):
       { status: 'livre' | 'ocupado' | 'invalido' | 'indeterminado', cupom_base, mensagem }
     'invalido' (nome que o backend recusa) e tratado como ocupado: ela precisa trocar de
     nome do mesmo jeito, e a mensagem do backend diz por que. 'indeterminado' (a Shopify
     nao respondeu) vira 'fora', com a mensagem do backend: honesto, e nao trava o envio. */
  function checaCupom(nome, ignoraCache) {
    if (!ignoraCache && Object.prototype.hasOwnProperty.call(cache, nome)) {
      return Promise.resolve({ desfecho: cache[nome] ? 'livre' : 'ocupado', motivo: null, doCache: true });
    }
    return pedir(URL_CUPOM, { cupom_base: nome }).then(function (r) {
      if (!r.rede) { return { desfecho: 'fora', motivo: null }; }
      if (r.http === 429) { return { desfecho: 'limite', motivo: null }; }
      var st = r.dados && typeof r.dados.status === 'string' ? r.dados.status : '';
      var msg = r.dados && typeof r.dados.mensagem === 'string' ? r.dados.mensagem : null;
      if (!r.ok || (st !== 'livre' && st !== 'ocupado' && st !== 'invalido' && st !== 'indeterminado')) {
        return { desfecho: 'fora', motivo: null };
      }
      if (st === 'indeterminado') { return { desfecho: 'fora', motivo: msg }; }
      cache[nome] = (st === 'livre');
      return { desfecho: st === 'livre' ? 'livre' : 'ocupado', motivo: msg };
    });
  }

  // O backend ja termina a mensagem de ocupado com "Escolha outro."; a tela emenda a
  // sugestao na mesma frase, entao a ponta repetida sai antes de emendar.
  function motivoOcupado(motivo, padrao) {
    var m = String(motivo || padrao).trim().replace(/\s*Escolha outro\.?$/i, '');
    return m + ' Escolha outro, ou toque numa sugestão.';
  }

  /* ------------------------------------------------- 6. NOME DO CUPOM VIVO */

  var relogioDebounce = null;
  var sequencia = 0;          // so a resposta da ultima digitacao pinta a tela
  var ultimoChecado = '';
  var estadoCupom = 'vazio';  // vazio | curto | checando | livre | ocupado | limite | fora
  // base -> lista, para nao sondar a mesma base duas vezes
  var sugestoesFeitas = {};

  function iniciaisDoNome() {
    var partes = semAcento(campos.nome.value || '').toUpperCase().replace(/[^A-Z ]/g, '').trim().split(/\s+/);
    if (partes.length < 2 || !partes[0]) { return ''; }
    return (partes[0].charAt(0) + partes[partes.length - 1].charAt(0));
  }

  function candidatos(base) {
    var lista = [];
    var ini = iniciaisDoNome();
    var brutos = [base + 'NUTRI', base + '10', base + 'OFICIAL', ini ? base + ini : '', base + 'BR', base + '20'];
    for (var i = 0; i < brutos.length; i++) {
      var c = normCupom(brutos[i]);
      if (c && c !== base && lista.indexOf(c) === -1) { lista.push(c); }
    }
    return lista.slice(0, MAX_SONDAS);
  }

  function pintaSugestoes(lista) {
    chips.innerHTML = '';
    if (!lista || !lista.length) { caixaSug.hidden = true; return; }
    for (var i = 0; i < lista.length; i++) {
      (function (nome) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'szpr-chip';
        b.textContent = nome;
        b.setAttribute('aria-label', 'Usar o nome ' + nome);
        b.addEventListener('click', function () {
          campos.cupom_base.value = nome;
          caixaSug.hidden = true;
          limpaErro('cupom_base');
          ultimoChecado = nome;
          estadoCupom = 'livre';
          dizStatus('livre', nome + ' está livre. É seu.');
          campos.cupom_base.focus();
        });
        chips.appendChild(b);
      }(lista[i]));
    }
    caixaSug.hidden = false;
  }

  // Sonda em serie, com pausa curta, e para no terceiro livre. Em serie de proposito:
  // o endpoint tem rate-limit e uma rajada de 6 chamadas juntas gastaria a cota da nutri.
  function buscaSugestoes(base) {
    if (sugestoesFeitas[base]) { pintaSugestoes(sugestoesFeitas[base]); return; }
    var lista = candidatos(base);
    var achados = [];
    var i = 0;

    function proximo() {
      if (i >= lista.length || achados.length >= 3) {
        sugestoesFeitas[base] = achados;
        pintaSugestoes(achados);
        return;
      }
      var nome = lista[i++];
      checaCupom(nome, false).then(function (r) {
        if (r.desfecho === 'livre') { achados.push(nome); }
        if (r.desfecho === 'fora' || r.desfecho === 'limite') {
          sugestoesFeitas[base] = achados;
          pintaSugestoes(achados);
          return;
        }
        setTimeout(proximo, 140);
      });
    }
    proximo();
  }

  function aoDigitarCupom() {
    var cru = campos.cupom_base.value;
    var limpo = normCupom(cru);
    if (limpo !== cru) {
      var fim = campos.cupom_base.selectionStart === cru.length;
      campos.cupom_base.value = limpo;
      if (fim) { try { campos.cupom_base.setSelectionRange(limpo.length, limpo.length); } catch (e) {} }
    }

    limpaErro('cupom_base');
    caixaSug.hidden = true;
    if (relogioDebounce) { clearTimeout(relogioDebounce); }

    if (!limpo.length) { estadoCupom = 'vazio'; girando(false); dizStatus(null, ''); return; }
    if (limpo.length < MIN_CUPOM) {
      estadoCupom = 'curto';
      girando(false);
      dizStatus('checando', 'Escreva pelo menos ' + MIN_CUPOM + ' caracteres.');
      return;
    }
    if (limpo === ultimoChecado && (estadoCupom === 'livre' || estadoCupom === 'ocupado')) { return; }

    estadoCupom = 'checando';
    girando(true);
    dizStatus('checando', 'Conferindo se ' + limpo + ' está livre...');

    var meu = ++sequencia;
    relogioDebounce = setTimeout(function () {
      checaCupom(limpo, false).then(function (r) {
        if (meu !== sequencia) { return; }   // ela continuou digitando, resposta velha
        girando(false);
        ultimoChecado = limpo;
        estadoCupom = r.desfecho;

        if (r.desfecho === 'livre') {
          dizStatus('livre', limpo + ' está livre. É seu.');
          caixaSug.hidden = true;
        } else if (r.desfecho === 'ocupado') {
          dizStatus('ocupado', motivoOcupado(r.motivo, 'Esse nome já está em uso.'));
          buscaSugestoes(limpo);
        } else if (r.desfecho === 'limite') {
          dizStatus('indisponivel', 'Muitas conferências seguidas. Espere alguns segundos e tente de novo.');
        } else {
          dizStatus('indisponivel', r.motivo || 'Não deu para conferir agora. Pode enviar assim mesmo, a gente confere no cadastro.');
        }
      });
    }, DEBOUNCE);
  }

  /* ------------------------------------------------------------ 7. ENVIO */

  /* O corpo, na ordem do contrato. faz_atendimentos e booleano JSON de verdade. As duas
     quantidades e a ponte atendimentos_semana (= soma) so entram quando a resposta foi
     Sim: com Nao, as tres chaves nem existem no corpo. */
  function corpoDoCadastro() {
    var sim = radioSim.checked === true;
    var corpo = {
      nome: String(campos.nome.value || '').trim().replace(/\s+/g, ' '),
      telefone: foneE164(campos.telefone.value),
      email: String(campos.email.value || '').trim().toLowerCase(),
      instagram: normInstagram(campos.instagram.value),
      crn: crnCompleto(campos.crn.value),
      cupom_base: normCupom(campos.cupom_base.value),
      faz_atendimentos: sim
    };
    if (sim) {
      corpo.atendimentos_presenciais = atend.presenciais;
      corpo.atendimentos_online = atend.online;
      corpo.atendimentos_semana = atend.presenciais + atend.online;
    }
    var rastreio = leRastreioDaUrl(window.location && window.location.search);
    if (rastreio.origem) { corpo.origem = rastreio.origem; }
    if (rastreio.uf) { corpo.uf = rastreio.uf; }
    if (rastreio.ref) { corpo.ref = rastreio.ref; }
    var chavesAnuncio = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'fbclid'];
    for (var ca = 0; ca < chavesAnuncio.length; ca++) {
      if (rastreio[chavesAnuncio[ca]]) { corpo[chavesAnuncio[ca]] = rastreio[chavesAnuncio[ca]]; }
    }
    var fbp = leCookie('_fbp');
    var fbc = leCookie('_fbc');
    if (fbp) { corpo.fbp = fbp; }
    if (fbc) { corpo.fbc = fbc; }
    return corpo;
  }

  /* Os cookies _fbp e _fbc que o pixel da Meta grava na loja (etapa41). So seguem para a API
     de conversoes do Ultron, que casa o Lead com o clique; nao sao gravados. */
  function leCookie(nome) {
    try {
      var partes = String(document.cookie || '').split(';');
      for (var i = 0; i < partes.length; i++) {
        var par = partes[i].split('=');
        if (String(par[0] || '').trim() === nome) {
          var v = decodeURIComponent(par.slice(1).join('=')).trim();
          return /^fb[.][0-2][.][0-9]{10,13}[.][A-Za-z0-9_.-]{1,500}$/.test(v) ? v : null;
        }
      }
    } catch (e) {}
    return null;
  }

  var CHAVES = ['nome', 'telefone', 'email', 'instagram', 'crn', 'cupom_base', 'faz_atendimentos',
    'atendimentos_presenciais', 'atendimentos_online', 'atendimentos_semana'];
  // Erro do backend numa das quantidades cola no grupo dos radios: e la que ela reabre o modal.
  var ALIAS = { atendimentos_presenciais: 'faz_atendimentos', atendimentos_online: 'faz_atendimentos', atendimentos_semana: 'faz_atendimentos' };
  function alvoDe(chave) { return Object.prototype.hasOwnProperty.call(ALIAS, chave) ? ALIAS[chave] : chave; }

  // O corpo de erro do backend ainda pode mudar de forma. Lemos as tres formas plausiveis
  // (mapa por campo, lista do class-validator, mensagem solta) e, quando nada casa com um
  // campo, o texto vai pro erro geral em vez de sumir.
  function espalhaErros(dados) {
    var achou = false;
    if (!dados) { return achou; }

    var mapa = dados.errors || dados.erros || dados.fields || null;
    if (mapa && !(mapa instanceof Array) && typeof mapa === 'object') {
      for (var k in mapa) {
        if (!Object.prototype.hasOwnProperty.call(mapa, k)) { continue; }
        if (CHAVES.indexOf(k) === -1) { continue; }
        var msg = mapa[k];
        if (msg instanceof Array) { msg = msg[0]; }
        mostraErro(alvoDe(k), String(msg));
        achou = true;
      }
      if (achou) { return achou; }
    }

    var lista = null;
    if (dados.message instanceof Array) { lista = dados.message; }
    else if (mapa instanceof Array) { lista = mapa; }
    if (lista) {
      for (var i = 0; i < lista.length; i++) {
        var texto = typeof lista[i] === 'string' ? lista[i] : (lista[i] && (lista[i].mensagem || lista[i].message) || '');
        var alvo = (lista[i] && (lista[i].campo || lista[i].field || lista[i].property)) || '';
        if (CHAVES.indexOf(alvo) === -1) {
          alvo = '';
          // as chaves compostas primeiro: "atendimentos_online" contem "atendimentos"
          for (var j = CHAVES.length - 1; j >= 0; j--) {
            if (String(texto).toLowerCase().indexOf(CHAVES[j]) !== -1) { alvo = CHAVES[j]; break; }
          }
        }
        if (alvo && texto) { mostraErro(alvoDe(alvo), String(texto)); achou = true; }
      }
    }
    return achou;
  }

  var ORDEM = ['nome', 'telefone', 'email', 'crn', 'instagram', 'faz_atendimentos', 'cupom_base', 'consent'];

  function primeiroInvalido() {
    var falhou = null;
    for (var i = 0; i < ORDEM.length; i++) {
      var msg = validaCampo(ORDEM[i]);
      if (msg) { mostraErro(ORDEM[i], msg); if (!falhou) { falhou = ORDEM[i]; } }
    }
    return falhou;
  }

  // Para onde o foco vai quando o campo falha. O grupo dos radios nao recebe foco: vai pro Sim.
  function focoDe(campo) {
    if (campo === 'faz_atendimentos') { return radioSim; }
    return campos[campo];
  }

  function trava(liga, texto) {
    btn.disabled = liga;
    btn.textContent = texto || 'Enviar cadastro';
  }

  /* EVENTO DE LEAD (etapa35, 22/set/26). O tema nao carrega fbq (o pixel da Meta entra
     pelo app, em sandbox de web pixel): quem dispara Lead e um pixel personalizado em
     Eventos de clientes, inscrito no evento de cliente prescritor_cadastrado publicado
     aqui. O event_id e o MESMO evento_id que vai no corpo do cadastro, para a Meta
     deduplicar navegador e servidor (parte B, Ultron). Nunca vai dado pessoal no evento:
     nem nome, telefone, e-mail, CRN ou Instagram. So roda no sucesso do cadastro.
     Qualquer falha aqui e engolida: o cadastro ja deu certo e a tela tem que mudar. */
  function novoEventoId() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') { return window.crypto.randomUUID(); }
    } catch (e) {}
    return 'szpr-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
  }

  function avisaLead(corpo) {
    try {
      var sh = window.Shopify;
      if (!sh || !sh.analytics || typeof sh.analytics.publish !== 'function') { return; }
      sh.analytics.publish('prescritor_cadastrado', {
        event_id: (corpo && corpo.evento_id) || novoEventoId(),
        faz_atendimentos: !!(corpo && corpo.faz_atendimentos === true),
        atendimentos_semana: (corpo && typeof corpo.atendimentos_semana === 'number') ? corpo.atendimentos_semana : 0
      });
    } catch (e) {}
  }

  function sucesso(corpo) {
    avisaLead(corpo);
    card.innerHTML =
      '<div class="szpr-ok">' +
      '<div class="szpr-ok-selo" aria-hidden="true">&#10003;</div>' +
      '<h2 tabindex="-1" id="szpr-ok-titulo">Cadastro recebido</h2>' +
      '<p>Seus cupons <span class="szpr-ok-forte">estão sendo criados agora</span>. ' +
      'Assim que ficarem prontos, a gente manda os códigos no WhatsApp que você cadastrou.</p>' +
      '<p>Não precisa fazer mais nada. Se tiver qualquer dúvida, é só responder a mensagem que chegar.</p>' +
      '<a class="szpr-ok-link" href="/collections/all">Conhecer os biscoitos seedz</a>' +
      '</div>';
    var titulo = document.getElementById('szpr-ok-titulo');
    if (titulo) { titulo.focus(); }
    try { card.scrollIntoView({ block: 'start', behavior: 'smooth' }); } catch (e) { card.scrollIntoView(); }
  }

  function envia(e) {
    if (e && e.preventDefault) { e.preventDefault(); }
    if (btn.disabled) { return; }

    var iscas = document.getElementById('szpr-site');
    if (iscas && iscas.value) { return; }   // robo. Nao envia, nao avisa.

    limpaTudo();
    var falhou = primeiroInvalido();
    if (falhou) {
      var alvo = focoDe(falhou);
      if (alvo && alvo.focus) { alvo.focus(); }
      return;
    }

    var corpo = corpoDoCadastro();
    // O id do evento de Lead nasce antes do envio e viaja no corpo (parte B deduplica).
    corpo.evento_id = novoEventoId();

    /* A SEGUNDA CHECAGEM. Entre a digitacao e o clique alguem pode ter levado o nome, e
       duas nutris com o mesmo cupom e um estrago que nao se desfaz. Se a checagem em si nao
       responder, seguimos: quem decide de verdade e o backend no cadastro, e travar aqui
       por causa de rede transformaria uma queda de sinal em cadastro perdido. */
    trava(true, 'Conferindo o cupom...');
    girando(true);

    checaCupom(corpo.cupom_base, true).then(function (r) {
      girando(false);
      if (r.desfecho === 'ocupado') {
        trava(false);
        estadoCupom = 'ocupado';
        ultimoChecado = corpo.cupom_base;
        dizStatus('ocupado', motivoOcupado(r.motivo, 'Esse nome acabou de ser levado.'));
        mostraErro('cupom_base', 'Escolha outro nome para o seu cupom.');
        buscaSugestoes(corpo.cupom_base);
        campos.cupom_base.focus();
        return;
      }
      if (r.desfecho === 'limite') {
        trava(false);
        erroGeral.textContent = 'Muitas tentativas seguidas. Espere alguns segundos e envie de novo.';
        return;
      }

      trava(true, 'Enviando...');
      pedir(URL_CADASTRO, corpo).then(function (res) {
        if (!res.rede) {
          trava(false);
          erroGeral.textContent = 'Não conseguimos falar com o servidor. Confira sua conexão e envie de novo, seus dados continuam preenchidos.';
          return;
        }
        if (res.ok && (!res.dados || res.dados.ok !== false)) { sucesso(corpo); return; }

        trava(false);

        if (res.http === 409) {
          var texto409 = res.dados && typeof res.dados.message === 'string' ? res.dados.message : '';
          // O backend tambem responde 409 para telefone que nao vira WhatsApp: esse erro e do
          // telefone, nao do cupom, e colar no cupom mandaria ela trocar o nome a toa.
          if (/telefone/i.test(texto409)) {
            mostraErro('telefone', texto409);
            campos.telefone.focus();
            return;
          }
          estadoCupom = 'ocupado';
          dizStatus('ocupado', motivoOcupado(texto409, 'Esse nome acabou de ser levado.'));
          mostraErro('cupom_base', 'Escolha outro nome para o seu cupom.');
          buscaSugestoes(corpo.cupom_base);
          campos.cupom_base.focus();
          return;
        }
        if (res.http === 429) {
          erroGeral.textContent = 'Muitas tentativas seguidas. Espere um minuto e envie de novo.';
          return;
        }

        var espalhou = espalhaErros(res.dados);
        if (espalhou) {
          var primeiro = form.querySelector('.szpr-f .szpr-erro:not(:empty)');
          if (primeiro && primeiro.parentNode) {
            var bloco = primeiro.parentNode.querySelector('input');
            if (bloco && bloco.focus) { bloco.focus(); }
          }
          return;
        }

        var msg = res.dados && typeof res.dados.message === 'string' ? res.dados.message : '';
        erroGeral.textContent = msg || 'Não deu para concluir o cadastro agora. Tente de novo em alguns minutos.';
      });
    });
  }

  /* ------------------------------------------------------------- 8. LIGA */

  campos.telefone.addEventListener('input', function () {
    var pos = campos.telefone.selectionStart === campos.telefone.value.length;
    campos.telefone.value = mascaraFone(campos.telefone.value);
    if (pos) {
      try { campos.telefone.setSelectionRange(campos.telefone.value.length, campos.telefone.value.length); } catch (e) {}
    }
    limpaErro('telefone');
  });

  campos.cupom_base.addEventListener('input', aoDigitarCupom);
  campos.cupom_base.addEventListener('blur', function () {
    var msg = validaCampo('cupom_base');
    if (msg) { mostraErro('cupom_base', msg); }
  });

  // O campo do CRN so aceita digito, e limpa na hora (se ela colar "CRN-3 12345", fica
  // "312345"). Mesma tecnica da mascara do telefone pra nao pular o cursor.
  campos.crn.addEventListener('input', function () {
    var cru = campos.crn.value;
    var limpo = crnDigitos(cru);
    if (limpo !== cru) {
      var fim = campos.crn.selectionStart === cru.length;
      campos.crn.value = limpo;
      if (fim) { try { campos.crn.setSelectionRange(limpo.length, limpo.length); } catch (e) {} }
    }
    limpaErro('crn');
  });

  campos.crn.addEventListener('blur', function () {
    var msg = validaCampo('crn');
    if (msg) { mostraErro('crn', msg); } else { limpaErro('crn'); }
  });

  campos.instagram.addEventListener('blur', function () {
    var ig = normInstagram(campos.instagram.value);
    if (ig) { campos.instagram.value = '@' + ig; }
  });

  var comBlur = ['nome', 'telefone', 'email', 'instagram'];
  for (var i = 0; i < comBlur.length; i++) {
    (function (campo) {
      campos[campo].addEventListener('blur', function () {
        var msg = validaCampo(campo);
        if (msg) { mostraErro(campo, msg); } else { limpaErro(campo); }
      });
      campos[campo].addEventListener('input', function () { limpaErro(campo); });
    }(comBlur[i]));
  }

  campos.consent.addEventListener('change', function () { limpaErro('consent'); });

  // "Voce faz atendimentos?"
  radioSim.addEventListener('change', function () { if (radioSim.checked) { aoMarcarSim(); } });
  radioNao.addEventListener('change', function () { if (radioNao.checked) { aoMarcarNao(); } });
  btnEditar.addEventListener('click', function () { if (atend.resposta === 'sim') { abreModal(); } });
  modal.form.addEventListener('submit', confirmaModal);
  modal.cancelar.addEventListener('click', function () { fechaModal('cancelar'); });
  modal.dialogo.addEventListener('close', aoFecharModal);
  // O fim da animacao de saida e quem autoriza o close() de verdade. O filtro de target
  // deixa passar o animationend do proprio dialogo (e o do ::backdrop, que o navegador
  // tambem entrega nele) e ignora o de qualquer filho.
  modal.dialogo.addEventListener('animationend', function (ev) {
    if (ev && ev.target && ev.target !== modal.dialogo) { return; }
    concluiFechamento();
  });
  // Esc: o cancel nativo fecharia sem animacao. Segura com preventDefault, anima, e fecha
  // igual ao Esc de sempre (returnValue vazio): o estado nao muda em nada. Um segundo Esc
  // durante a saida cai no early-return de fechaModal e nao duplica nada.
  modal.dialogo.addEventListener('cancel', function (ev) {
    if (!suportaAnimacao()) { return; }
    if (ev && ev.preventDefault) { ev.preventDefault(); }
    fechaModal('');
  });
  // Se o navegador fechou por fora durante a saida (um segundo Esc que o Chrome forca,
  // por exemplo), aborta a espera: sem timer pendurado e sem classe presa no reabrir.
  modal.dialogo.addEventListener('close', function () {
    if (!fechando.ativo) { return; }
    fechando.ativo = false;
    if (fechando.timer !== null) { clearTimeout(fechando.timer); fechando.timer = null; }
    tiraClasseSaindo();
  });
  modal.presenciais.addEventListener('input', function () { modal.erroPresenciais.textContent = ''; modal.presenciais.removeAttribute('aria-invalid'); atualizaConfirmar(); });
  modal.online.addEventListener('input', function () { modal.erroOnline.textContent = ''; modal.online.removeAttribute('aria-invalid'); atualizaConfirmar(); });
  // Se o navegador restaurou um radio marcado (volta de pagina), a pilula acompanha; a
  // resposta so vale de novo quando ela passar pelo modal, entao o Sim restaurado exige
  // as quantidades outra vez.
  if (radioSim.checked) { atend.resposta = 'sim'; } else if (radioNao.checked) { atend.resposta = 'nao'; }
  pintaRadios();
  pintaResumo();

  form.addEventListener('submit', envia);
}());
